import { normalizePublicLink, storeCategorySlug } from "./publicNavigation";

/* ── Category definitions with product images ── */
export const STORE_CATEGORIES = [
  {
    id: "고속인쇄기", slug: "high-speed-printer", label: "고속 인쇄기", tKey: "home_catDigital",
    img: "/api/category-images/1.고속인쇄기.webp", fallback: "/assets/de/cat-1.webp",
  },
  {
    id: "디자인용복합기", slug: "design-copier", label: "디자인용 복합기", tKey: "home_catDesign",
    img: "/api/category-images/2.복합기.webp", fallback: "/assets/de/cat-2.webp",
  },
  {
    id: "사무용복합기", slug: "office-copier", label: "사무용 복합기", tKey: "home_catOffice",
    img: "/api/category-images/2.복합기.webp", fallback: "/assets/de/cat-2.webp",
  },
  {
    id: "소형복합기", slug: "compact-copier", label: "소형복합기", tKey: "home_catSmall",
    img: "/api/category-images/3.소형복합기.webp", fallback: "/assets/de/cat-3.webp",
  },
  {
    id: "프린터", slug: "printer", label: "프린터", tKey: "home_catPrinter",
    img: "/api/category-images/4.프린터.webp", fallback: "/assets/de/cat-4.webp",
  },
  {
    id: "토너소모품", slug: "toner-supplies", label: "토너·소모품", tKey: "home_catToner",
    img: "/images/categories/toner-cmyk-20261025.webp", fallback: "/images/categories/toner-cmyk-20261025.webp",
  },
];


// Saved homepage categories may use a different order and legacy Korean URLs.
// Resolve the category itself; array positions never identify product images.
export function findStoreCategory(item = {}) {
  const link = normalizePublicLink(item.link, "");
  const path = link.split(/[?#]/)[0];
  return STORE_CATEGORIES.find((category) => path === `/store/${category.slug}`)
    || STORE_CATEGORIES.find((category) => category.slug === storeCategorySlug(item.name || item.id || ""));
}
